import { SelectFormField } from "@/app/components/form-fields/SelectFormField";
import {
  IPrivateContext,
  PrivateContext,
} from "@/app/components/PrivateContextLoader";
import { Entity, IUserField } from "@/app/fields/types";
import { useContext } from "react";

export const UserFormField = <T extends Entity>({
  field,
  isDisabled,
}: {
  field: IUserField<T>;
  isDisabled?: boolean;
}) => {
  const { users } = useContext(PrivateContext) as IPrivateContext<T>;
  return (
    <SelectFormField
      field={{ ...field, type: "select", is_multi: false }}
      options={(users || []).map(({ first_name, last_name, id }) => ({
        label: `${first_name} ${last_name}`,
        value: id,
        group: null,
      }))}
      isDisabled={isDisabled}
    />
  );
};
